import { jsx as o } from "react/jsx-runtime";
import { getIconStyles as l } from "../styles.js";
const t = (e) => /* @__PURE__ */ o(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: l(e),
    children: /* @__PURE__ */ o(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9997 7.35401L22.2088 17.5631C22.5993 17.9537 23.2325 17.9537 23.623 17.5631C24.0135 17.1726 24.0135 16.5394 23.623 16.1489L13.2375 5.7634C13.0752 5.60096 12.8819 5.47158 12.6698 5.38362C12.4574 5.29557 12.2298 5.25024 11.9999 5.25024C11.77 5.25024 11.5424 5.29557 11.33 5.38362C11.118 5.47153 10.9253 5.60032 10.763 5.76263L10.7623 5.7634L0.353762 16.1481C-0.0372094 16.5382 -0.0379341 17.1714 0.352143 17.5623C0.74222 17.9533 1.37538 17.954 1.76636 17.5639L11.9997 7.35401Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  t as ChevronUpIcon
};
//# sourceMappingURL=ChevronUpIcon.js.map
